<template>
  <div>
    <el-card shadow="always">
      <el-page-header
        title="Home"
        @back="$router.push({ name: 'home' })"
        :content="$t('cadastro-rotas')"
      ></el-page-header>
    </el-card>
    <br />
    <el-card>
      <el-row type="flex" justify="end">
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-input
            :placeholder="$t('pesquisar')"
            prefix-icon="el-icon-search"
            v-model="filter"
          ></el-input>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button
            class="right"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
            >{{ $t('adicionar') }}</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="
          tableData.filter(
            (data) =>
              !filter ||
              data.description.toLowerCase().includes(filter.toLowerCase())
          )
        "
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'position', order: 'ascending' }"
      >
        <el-table-column
          prop="description"
          :label="$t('descricao')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="active"
          :label="$t('ativa')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="createdAt"
          :label="$t('data-criacao')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="type"
          :label="$t('tipo')"
        ></el-table-column>

        <el-table-column label="" width="180">
          <template slot-scope="scope">
            <el-button
              type="info"
              icon="el-icon-edit"
              @click="editar(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.description)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>
<script>
import { RouteService } from '@/services/umov/route.services';
import { i18n } from '@/plugin/i18n';

export default {
  name: 'Packing',
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);

      RouteService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc('erro'),
            message: error,
          });
        })
        .finally(() => loading.close());
    },

    add() {
      const vm = this;
      vm.$router.replace({ name: 'route.add' });
    },

    editar: function(id) {
      const vm = this;

      vm.$router.replace({
        name: 'route.edit',
        params: { id: id },
      });
    },

    remove: function(id, name) {
      const vm = this;
      this.$confirm(
        i18n.t('confirmar-eliminacao-rota', { id: name }),
        i18n.tc('aviso'),
        {
          confirmButtonText: 'OK',
          cancelButtonText: i18n.tc('cancelar'),
          type: i18n.tc('aviso'),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        RouteService.delete(id)
          .then((response) => {
            setTimeout(() => {
              const index = vm.tableData.findIndex((dt) => dt.id == id);
              vm.tableData.splice(index, 1);
            }, 300);
            this.$message({
              type: 'success',
              message: i18n.tc('rota-eliminado-sucesso'),
            });
          })
          .catch((error) => {
            console.log('error', error)
            vm.$message({
              type: 'error',
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
  },

  mounted() {
    const vm = this;
    vm.fetchRecords();
  },

  data() {
    return {
      filter: '',
      tableData: [],
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>
